import React, { useState } from "react";
import { Folder, MoreVertical, Edit2, Trash2, ChevronRight } from "lucide-react";

export default function FolderCard({
  folder,
  itemCount = 0,
  onClick,
  onEdit,
  onDelete
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const color = folder.color || "#3B82F6";

  return (
    <div
      className="marketing-folder-card"
      onClick={() => onClick(folder)}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1rem 1.15rem",
        backgroundColor: "var(--bg-card)",
        border: "1px solid var(--border-color)",
        borderRadius: "10px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "var(--shadow-sm)"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.borderColor = color;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.borderColor = "var(--border-color)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.85rem", minWidth: 0, flex: 1 }}>
        <div
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "8px",
            backgroundColor: `${color}18`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: color,
            flexShrink: 0
          }}
        >
          <Folder size={22} />
        </div>

        <div style={{ minWidth: 0, flex: 1 }}>
          <div 
            style={{ 
              fontWeight: 600, 
              color: "var(--text-primary)", 
              fontSize: "0.95rem",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {folder.name}
          </div>
          <div style={{ fontSize: "0.75rem", color: "var(--text-secondary)", marginTop: "0.15rem" }}>
            {itemCount} {itemCount === 1 ? "item" : "items"}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "0.3rem", position: "relative" }} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            background: "none",
            border: "none",
            color: "var(--text-muted)",
            cursor: "pointer",
            padding: "0.3rem",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center"
          }}
          title="Folder options"
        >
          <MoreVertical size={16} />
        </button>

        {menuOpen && (
          <>
            <div 
              style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 90 }} 
              onClick={() => setMenuOpen(false)} 
            />
            <div
              style={{
                position: "absolute",
                top: "100%",
                right: 0,
                marginTop: "0.35rem",
                backgroundColor: "var(--bg-card)",
                border: "1px solid var(--border-color)",
                borderRadius: "8px",
                boxShadow: "var(--shadow-md)",
                zIndex: 100,
                minWidth: "130px",
                overflow: "hidden"
              }}
            >
              <button
                type="button"
                onClick={() => { setMenuOpen(false); onEdit(folder); }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  width: "100%",
                  padding: "0.6rem 0.85rem",
                  background: "none",
                  border: "none",
                  color: "var(--text-primary)",
                  fontSize: "0.85rem",
                  cursor: "pointer",
                  textAlign: "left"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--bg-input)"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
              >
                <Edit2 size={14} /> Rename
              </button>
              <button
                type="button"
                onClick={() => { setMenuOpen(false); onDelete(folder); }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  width: "100%",
                  padding: "0.6rem 0.85rem",
                  background: "none",
                  border: "none",
                  color: "var(--danger)",
                  fontSize: "0.85rem",
                  cursor: "pointer",
                  textAlign: "left",
                  borderTop: "1px solid var(--border-color)"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--bg-input)"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
              >
                <Trash2 size={14} /> Delete
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
